<template>
    <li :class="'accordion__item ' + (disabled ? ' accordion__item--disabled' : '')">
        <div
            v-if="!noHead"
            class="accordion__item-head"
            :class="{'is-active': visible}"
            @click="open"
        >
            <button class="accordion__item-btn text-start">
                <slot name="accordion-trigger"></slot>

                <span class="accordion__item-icon ms-auto icon icon-chevron-down" />
            </button>
        </div>

        <Transition
            name="accordion"
            @before-enter="collapsing"
            @enter="start"
            @after-enter="end"
            @before-leave="start"
            @leave="collapsing"
            @after-leave="end"
        >
            <div class="accordion__body" v-show="visible">
                <div class="accordion__body-content">
                    <slot name="accordion-content"></slot>
                </div>
            </div>
        </Transition>
    </li>
</template>

<script>

export default {
    name: 'AccordionItem',
    props: {
        noHead: Boolean,
        disabled: Boolean
    },
    inject: ["Accordion"],
    data() {
        return {
            index: null
        };
    },
    computed: {
        visible() {
            return this.index === this.Accordion.active;
        }
    },
    methods: {
        open() {
            if (this.visible) {
                this.Accordion.active = null;

                this.$emit('accordionClosed');
            } else {
                this.Accordion.active = this.index;

                this.$emit('accordionOpened');
            }
        },
        close() {
            this.Accordion.active = null;
        },
        start(el) {
            el.style.height = el.scrollHeight + "px";
        },
        collapsing(el) {
            el.style.height = "0px";
            el.style.overflow = "hidden";
        },
        end(el) {
            el.style.height = "";
            el.style.overflow = '';
        }
    },
    created() {
        this.index = this.Accordion.count++;
    }
}
</script>

<style lang="scss">
.accordion__item {
    margin-bottom: 15px;
    transition: all 200ms linear;
    background: #fff;
    box-shadow: 0 2rem 5rem 0 rgba(36,86,133,0.32);

    &:last-child {
        margin-bottom: 0;
    }
    & + .accordion__item {
        margin-top: .5rem;
    }
}

.accordion__item--disabled {
    position: relative;
    pointer-events: none;
    background: #00000010;
    & .ticket-configuration__small-title {
        color: var(--color-middle-grey);
    }
}
.accordion__item-btn {
    border: none;
    width: 100%;
    background: none;
    color: inherit;
    font-size: calc(22rem / 16);
    line-height: calc(25/22);
    display: block;
    position: relative;
    padding: calc(16rem / 16) calc(50rem / 16) calc(16rem / 16) calc(16rem / 16);
    @media screen and (min-width: 768px){
        padding: calc(32rem / 16) calc(50rem / 16) calc(32rem / 16) calc(32rem / 16);
    }
}
.accordion__item-icon {
    position: absolute;
    right: calc(18rem / 16);
    top: 50%;
    transform: translateY(-50%);
    transition: transform 200ms ease-in-out;
}
.is-active .accordion__item-icon {
    transform: translateY(-50%) rotate(180deg);
}

.accordion__body {
    transition: height 350ms ease;
}
.accordion__body-content {
    padding: 0 calc(16rem / 16) calc(16rem / 16);
    @media screen and (min-width: 768px){
        padding: 0 calc(32rem / 16) calc(32rem / 16);
    }
}
.accordion__body-content p:last-child {
    margin-bottom: 0;
}

/* plain style */
.accordion--plain .accordion__item {
    border: 0;
}
.accordion--plain .accordion__body-content {
    padding: 0;
}

.accordion--plain-sm .accordion__item-btn {
    padding: calc(10rem / 16) calc(10rem / 16);
    font-size: calc(17rem / 16);

    .accordion__item-icon {
        top: calc(14rem / 16);
    }
}

/* button style */
.accordion--btn .accordion__item {
    border: 1px solid var(--color-secondary);
}
.accordion--btn .accordion__item-btn {
    font-size: calc(14rem / 16);
    line-height: calc(20/14);

    .accordion__item-icon {
        top: 50%;
        transform: translateY(-50%);
    }
}

/* accordion with input */
.accordion--input .accordion__body {
    padding-left: calc(40rem / 16);
}
</style>
